export const UsedProcutSaleType = {
  NO_SALE: 0,
  WAS_NOW: 1,
  WAS_CASH_NO_TRADE: 2,
  LEASE: 3,

  LABEL_WAS_NOW_DEFAULT : "SPECIAL PRICING",
  LABEL_WAS_CASH_NO_TRADE_DEFAULT : "CASH/NO TRADE",
  LABEL_DEFAULT_LEASE : "LEASE",
}



// WEBPACK FOOTER //
// ./resources/js/data/we_enums.js